import HTTP from './http'
const BASE_URL = '/invite'

import Store from '@/store'
import { uniqBy } from 'lodash-es'

const userAccountKey = () => (Store.getters['user/accountInfo'] ? Store.getters['user/accountInfo'].accountKey : 0)

export default {
  async inviteToCompanyBulk({ companyKey, emailList }) {
    const payload = emailList.map((email) => {
      return {
        inviteAccountType: 'shipper',
        inviteAccountEmailAddress: email,
        inviteToCompanyKey: companyKey
      }
    })

    const response = await HTTP.post(`${BASE_URL}/list`, payload)
    return response.data.data
  },

  async inviteToCompany(inviteInfo) {
    const response = await HTTP.post(`${BASE_URL}`, inviteInfo)
    return response.data.data
  },

  async _inviteToJobBulk({ jobKey, recipientList, inviteType }) {
    const payload = recipientList.map((recipient) => {
      return {
        inviteAccountEmailAddress: recipient.email,
        inviteAccountFirstName: recipient.name,
        inviteAccountLastName: '',
        // because the data model forces a phone number... we set a fake one by default in case the user does not put one in
        invitePhone: recipient.phone || null,
        inviteAccountType: inviteType,
        inviteToJobKey: jobKey,
        inviteByAccountKey: userAccountKey()
      }
    })

    const response = await HTTP.post(`${BASE_URL}/list`, payload)
    return response.data.data
  },

  async inviteCarrierToJobBulk({ jobKey, recipientList }) {
    if (recipientList.length === 0) {
      return
    }
    return this._inviteToJobBulk({ jobKey, recipientList, inviteType: 'carrier' })
  },

  async inviteRecipientToJobBulk({ jobKey, recipientList }) {
    if (recipientList.length === 0) {
      return
    }
    return this._inviteToJobBulk({ jobKey, recipientList, inviteType: 'recipient' })
  },

  async companyJobInviteList({ companyJobKey }) {
    const params = {
      companyJobKey
    }
    // depending on the email address that was invited... it could be considered an "internal" account (aka: they have a
    // truckl account) or an "external" account (aka: they do not yet have a truckl account).
    // these type of invites are tracked and treated differently on the backend, but the UI needs to show all of them.
    const internalInviteResponse = HTTP.get('/companyjob/invite/list', { params })
    const externalInviteResponse = HTTP.get(`${BASE_URL}/list`, { params })

    const [internal, external] = await Promise.all([internalInviteResponse, externalInviteResponse])
    const cleanedupInternals = internal.data.data.map((invite) => {
      const accountPhone = invite.account.accountPhones.length
        ? invite.account.accountPhones[0].accountPhoneDigits
        : null
      return {
        inviteAccountEmailAddress: invite.account.accountEmailAddress,
        email: invite.account.accountEmailAddress,
        inviteAccountFirstName: invite.account.accountFirstName,
        inviteAccountLastName: invite.account.accountLastName,
        inviteAccountType: invite.account.accountType,
        invitePhone: accountPhone
      }
    })
    const combinedList = [...cleanedupInternals, ...external.data.data]

    // because of the "internal" vs "external" stuff mentioned above.. there is a case where we end up with what appears
    // to be duplicates (ie: we invite an "external" carrier account which then registers and turns in to an "internal"
    // account... at which point they would show up in BOTH lists... so we de-dupe them based on email address, but make
    // sure the internal account info take priority
    return uniqBy(combinedList, 'inviteAccountEmailAddress')
  }
}
